/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import { Fragment, Slice } from 'prosemirror-model';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { findAllNodes } from '../utils/nodeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function VideoConferenceButton(props) {
  const {
    ToolbarButton
  } = props;
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const prosemirrorProps = {
    updateConferenceTime: ({
      getAppName,
      ConfirmUpdateModal,
      getMetadata
    }) => {
      const allConferenceNodePoses = findAllNodes(editorState.doc, node => node.type === editorState.schema.nodes.videoConferenceLink);
      if (allConferenceNodePoses.length) {
        const firstNode = allConferenceNodePoses[0].node;
        const globalAppId = firstNode && firstNode.attrs.appId;
        const appName = getAppName(globalAppId);
        ConfirmUpdateModal({
          appName
        }).then(() => allConferenceNodePoses.forEach(nodePos => {
          const {
            appId,
            accountId
          } = nodePos.node.attrs;
          getMetadata(appId, accountId).then(metadata => {
            const {
              conferenceId,
              text,
              url,
              contentType
            } = metadata.toJS();
            setEditorState(editorState.apply(editorState.tr.setNodeMarkup(nodePos.pos, undefined, {
              accountId,
              appId,
              conferenceId,
              text,
              url,
              contentType
            })));
          });
        }));
      }
    },
    insertConferenceLink: videoMetaData => {
      const {
        accountId,
        appId,
        conferenceId,
        text,
        url,
        contentType
      } = videoMetaData;
      const {
        schema
      } = editorState;
      const conferenceNode = schema.nodes.videoConferenceLink.create({
        accountId,
        appId,
        conferenceId,
        text,
        url,
        contentType
      });
      setEditorState(editorState.apply(editorState.tr.replaceSelection(new Slice(Fragment.fromArray([schema.nodes.paragraph.create(), conferenceNode, schema.nodes.paragraph.create()]), 0, 0))));
    }
  };
  return /*#__PURE__*/_jsx(ToolbarButton, {
    prosemirrorProps: prosemirrorProps
  });
}